import Typography from "@mui/joy/Typography";
import { useCallback, useEffect, useState } from "react";
import { CircularProgress, Stack } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import {
  CONCEPT_DOMAIN,
  CONCEPT_MEMOLOAD_ENDPOINT,
  conceptApi,
  MemoType,
} from "api/conceptApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConceptNoteInput from "./ConceptNoteInput";

export default function Memo() {
  const patientState = useRecoilValue(patientAtom);
  const queryClient = useQueryClient();
  const [memo, setMemo] = useState<string>("");

  const { mutate: saveMemo } = useMutation(
    (payload: string) =>
      conceptApi.memoSave(`${patientState?.patientId}`, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          CONCEPT_DOMAIN,
          CONCEPT_MEMOLOAD_ENDPOINT,
          patientState?.patientId,
        ]);
        setMemo((prev) => prev); // trigger re-render
      },
    }
  );

  const { refetch: loadMemo, isLoading } = useQuery(
    [CONCEPT_DOMAIN, CONCEPT_MEMOLOAD_ENDPOINT, patientState?.patientId],
    () => conceptApi.memoLoad(`${patientState?.patientId}`),
    {
      enabled: !!patientState?.patientId,
      onSuccess: (data) => {
        if (data && data.result) {
          setMemo((data.result as MemoType).memo);
        }
      },
    }
  );

  useEffect(() => {
    loadMemo();
  }, [patientState?.patientId]);

  const handleSave = useCallback(
    (newMemo: string) => {
      setMemo(newMemo);
      saveMemo(newMemo);
    },
    [saveMemo]
  );

  return (
    <Stack spacing={1}>
      <Stack direction={"row"} justifyContent="space-between">
        <Typography level="body-xs">{"메모"}</Typography>
      </Stack>
      {isLoading ? (
        <CircularProgress color="neutral" />
      ) : (
        <ConceptNoteInput initialValue={memo} onSave={handleSave} />
      )}
    </Stack>
  );
}
